<div class="wrapper-express-checkout">
  <!-- Page header -->
  <div class="ec-header" #pageHeader>
    <div class="ec-header__left">
      <a routerLink="/dashboard/express-checkout" class="ec-back" aria-label="Back">
        <i class="fi-rr-arrow-alt-left"></i>
      </a>
      <div class="ec-header__title-block">
        <h1 class="ec-header__title">{{ "Express Checkout" | translate }}</h1>
      </div>
    </div>
    <div class="ec-header__right">
      <button class="btn btn-primary" (click)="generatelink()" [disabled]="buttonFreeze"
        *ngIf="!updateLink && !isEditLoading">
        <i class="fi fi-rr-link mr-1"></i>
        {{ "Create Checkout Link" | translate }}
      </button>
      <button class="btn btn-primary" (click)="updatelink()" [disabled]="buttonFreeze"
        *ngIf="updateLink && !isEditLoading">
        <i class="fi fi-rr-check mr-1"></i>
        {{ "Save Changes" | translate }}
      </button>
    </div>
  </div>

  <!-- Main content -->
  <div class="ec-main" *ngIf="!checkoutSuccess">
    <!-- Loading state while an existing checkout's data is being fetched -->
    <div class="ec-page-loading" *ngIf="isEditLoading">
      <mat-spinner [diameter]="48"></mat-spinner>
      <p class="ec-page-loading__text">{{ "Loading checkout..." | translate }}</p>
    </div>

    <form [formGroup]="generateForm" class="ec-grid" *ngIf="!isEditLoading">
      <!-- LEFT: Settings column -->
      <div class="ec-grid__left">
        <!-- Checkout Settings -->
        <section class="ec-card ec-card--overflow-visible">
          <header class="ec-card__header">
            <span class="ec-card__icon">
              <i class="fi fi-rr-settings-sliders"></i>
            </span>
            <h2 class="ec-card__title">{{ "Checkout Settings" | translate }}</h2>
          </header>

          <div class="ec-card__body">
            <div class="ec-row-2">
              <div class="ec-field">
                <label class="ec-label">{{ "Select Country" | translate }}</label>
                <div ngbDropdown class="ec-dropdown"
                  [class.is-loading]="!countryLoaded || !countryFirstInit"
                  [class.is-disabled]="isEditMode">
                  <button type="button" class="ec-select" ngbDropdownToggle
                    [disabled]="isEditMode">
                    <span>{{ getCountryName(filteredCountry) | translate }}</span>
                    <i class="fi fi-rr-angle-small-down"></i>
                  </button>
                  <div ngbDropdownMenu class="ec-dropdown-menu">
                    <button type="button" ngbDropdownItem *ngFor="let c of activatedCountry"
                      (click)="changeCountry(c.country_code)">
                      {{ c.country_name | translate }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="ec-field">
                <label class="ec-label">{{ "Select Language" | translate }}</label>
                <div ngbDropdown class="ec-dropdown"
                  [class.is-loading]="!countryLoaded || !countryFirstInit"
                  [class.is-disabled]="isEditMode">
                  <button type="button" class="ec-select" ngbDropdownToggle
                    [disabled]="isEditMode">
                    <span>{{ getLanguageName(currentLanguage) || ("Language" | translate) }}</span>
                    <i class="fi fi-rr-angle-small-down"></i>
                  </button>
                  <div ngbDropdownMenu class="ec-dropdown-menu">
                    <button type="button" ngbDropdownItem *ngFor="let language of languageList"
                      (click)="changeLanguage(language)">
                      {{ language.language_name }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="ec-field">
              <label class="ec-label required" for="page-title">{{ "Page Title" | translate }}</label>
              <input class="ec-input" type="text" id="page-title" name="page-title"
                formControlName="page_title"
                placeholder="{{ 'e.g. Summer Collection Promotion' | translate }}" />
            </div>

            <div class="ec-field">
              <label class="ec-label required" for="url">{{ "Page URL Slug" | translate }}</label>
              <div class="ec-slug">
                <span class="ec-slug__prefix">/checkout/</span>
                <input class="ec-slug__input" type="text" id="url" name="url"
                  (input)="filterNonUrlCharacters($event)" formControlName="url"
                  placeholder="{{ 'e.g. summer-deals' | translate }}" />
              </div>
              <p class="ec-helper">
                {{ "Only lowercase letters, numbers, and dashes are allowed" | translate }}
              </p>
              <p class="ec-helper ec-helper--info" *ngIf="!isTaiwanLocal">
                <i class="fi fi-rr-info"></i>
                {{ "Note: This slug sets the checkout page URL only — it is not used for the product link domain." | translate }}
              </p>
            </div>

            <!-- Product Link (hidden for the Taiwan TWTW store) -->
            <div class="ec-field" *ngIf="!isTaiwanLocal">
              <label class="ec-toggle-row">
                <span class="ec-switch">
                  <input type="checkbox" [checked]="showProductLink"
                    (change)="toggleProductLink()" />
                  <span class="ec-switch__track"></span>
                </span>
                <span class="ec-toggle-row__text">
                  <span class="ec-label">{{ "Product Link" | translate }}</span>
                </span>
              </label>

              <div ngbDropdown placement="top-start" class="ec-dropdown ec-toggle-row__dropdown"
                *ngIf="showProductLink">
                <button type="button" class="ec-select" ngbDropdownToggle
                  [disabled]="productLinkLoading">
                  <span>{{ productLinkLoading
                    ? ("Loading domains..." | translate)
                    : (selectedProductLinkDomain || ("Select a domain" | translate)) }}</span>
                  <i class="fi fi-rr-angle-small-down"></i>
                </button>
                <div ngbDropdownMenu class="ec-dropdown-menu">
                  <button type="button" ngbDropdownItem
                    *ngFor="let domain of productLinkDomains"
                    (click)="selectProductLinkDomain(domain)">
                    {{ domain }}
                  </button>
                  <div class="ec-empty" *ngIf="!productLinkDomains.length">
                    {{ "No domain found." | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="ec-field">
              <label class="ec-label" for="description">{{ "Description" | translate }}</label>
              <textarea id="description" class="ec-textarea" name="description"
                formControlName="description"
                placeholder="{{ 'Describe your promotion, shipping deals, or discount rules...' | translate }}"></textarea>
            </div>
          </div>
        </section>

        <!-- Select Products -->
        <section class="ec-card">
          <header class="ec-card__header">
            <span class="ec-card__icon">
              <i class="fi fi-rr-boxes"></i>
            </span>
            <h2 class="ec-card__title">{{ "Select Products" | translate }}</h2>
          </header>

          <div class="ec-card__body">
            <div class="ec-search">
              <i class="fi fi-rr-search ec-search__icon"></i>
              <input class="ec-search__input" type="text" name="product-filter" id="product-filter"
                [value]="productFilter" (input)="productFilterChanged($event)"
                placeholder="{{ 'Search product by name...' | translate }}" />
            </div>

            <div *ngIf="productFilter.length" class="ec-search__hint">
              {{ "Searching for '{0}'..." | translate : [productFilter] }}
            </div>

            <div class="ec-subscription-tabs" *ngIf="showSubscriptionTab && subscriptionProduct">
              <button type="button" class="ec-subscription-tab"
                *ngFor="let sub of subscription_status"
                [class.active]="sub === subscription"
                (click)="changeSubscription(sub)">
                {{ sub | translate }}
              </button>
            </div>

            <div class="ec-product-list" *ngIf="!loading && !(subscriptionApiLoading && is_subscription === 1 && !isTaiwanLocal)">
              <div class="ec-product-grid" *ngIf="getDisplayedProducts()?.length">
                <button type="button" class="ec-product-card"
                  *ngFor="let item of getDisplayedProducts()"
                  [class.selected]="isProductSelected(item.p_id)"
                  [class.is-disabled]="isOutOfStock(item)"
                  [class.is-oos]="isOutOfStock(item) && !isProductSelected(item.p_id)"
                  (click)="productClick(item.p_id, item.mixture_arr)">
                  <div class="ec-product-card__media">
                    <span class="ec-product-card__flag"
                      #tooltip="matTooltip" [matTooltip]="getCountryName(item?.country_code)"
                      matTooltipPosition="above" matTooltipHideDelay="100">
                      <img [src]="getFlagImageURL(item?.country_code)" />
                    </span>
                    <img class="ec-product-card__img" [src]="item.image || 'https://cdn.estore5s.com/asset/images/estore_missing_product.png'"
                      onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/images/estore_missing_product.png';" />
                  </div>
                  <div class="ec-product-card__info">
                    <div class="ec-product-card__name">{{ item.product_name?.toLowerCase() }}</div>
                    <div class="ec-product-card__price">
                      {{ item.retail_price_per_item | currency : item.currency : item.currency_symbol + ' ' }}
                    </div>
                    <!-- Can't be newly selected; an already-selected one stays
                         (and stays removable) so editing a link whose product
                         has since sold out doesn't silently drop it. -->
                    <div class="ec-oos" *ngIf="isOutOfStock(item)">
                      {{ "Out of stock" | translate }}
                    </div>
                  </div>
                  <div class="ec-product-card__radio" aria-hidden="true">
                    <span class="ec-product-card__radio-dot"></span>
                  </div>
                </button>
              </div>

              <div class="ec-empty" *ngIf="!getDisplayedProducts()?.length">
                {{ "No product found." | translate }}
              </div>
            </div>

            <div class="ec-loading" *ngIf="loading || (subscriptionApiLoading && is_subscription === 1 && !isTaiwanLocal)">
              <mat-spinner [diameter]="40"></mat-spinner>
            </div>
          </div>
        </section>

        <!-- Product Quantity Settings. Two tabs: the products the link sells,
             and — once a selected product unlocks a Purchase With Purchase
             promotion — the PWP products, whose settings live on
             `pwpProductSettings` (not form controls). The PWP tab is hidden on
             TWTW, which keeps the legacy checkout layout and does not offer
             the setting. -->
        <section class="ec-card">
          <header class="ec-card__header">
            <span class="ec-card__icon">
              <i class="fi fi-rr-calculator"></i>
            </span>
            <h2 class="ec-card__title">{{ "Product Quantity Settings" | translate }}</h2>
          </header>

          <div class="ec-card__body">
            <div class="ec-subscription-tabs ec-qty-tabs" *ngIf="hasPwpEntries()">
              <button type="button" class="ec-subscription-tab"
                [class.active]="quantityTab === 'products'"
                (click)="quantityTab = 'products'">
                {{ "Products" | translate }}
              </button>
              <button type="button" class="ec-subscription-tab"
                [class.active]="quantityTab === 'pwp'"
                (click)="quantityTab = 'pwp'">
                {{ "PWP Products" | translate }}
                <span class="ec-qty-tabs__count">{{ getPwpEntries().length }}</span>
              </button>
            </div>

            <!-- Falls back to the product tab when the PWP tab was open and the
                 last qualifying product has been deselected. -->
            <ng-container *ngIf="quantityTab === 'products' || !hasPwpEntries()">
              <div class="ec-note">
                {{ "Tailor your customer shopping experience. Personalize default product quantities to suit your preferences right here!" | translate }}
              </div>
              <div class="ec-helper" *ngIf="!isTaiwanLocal">
                {{ "Lock quantity fixes the amount a customer buys — the checkout page shows the quantity without the − and + buttons." | translate }}
              </div>

              <!-- Grid list: the header names the control columns once, so
                   each row carries icon toggles instead of labelled switches.
                   TWTW has no Lock column (legacy checkout layout). -->
              <div class="ec-qty-list ec-qty-grid" *ngIf="selectedProducts.length"
                [class.ec-qty-grid--no-lock]="isTaiwanLocal">
                <div class="ec-qty-head" aria-hidden="true">
                  <span class="ec-qty-head__product">{{ "Product" | translate }}</span>
                  <span>{{ "Quantity" | translate }}</span>
                  <span *ngIf="!isTaiwanLocal">{{ "Lock" | translate }}</span>
                  <span></span>
                </div>

                <ng-container *ngFor="let product of selectedProducts">
                  <div class="ec-qty-row" *ngIf="getProductData(product.product_id)">
                    <div class="ec-qty-product">
                      <img *ngIf="(getProductData(product.product_id)?.isSubscriptionPlan ? getSubscriptionImage(product.product_id, product.quantity) : getProductData(product.product_id)?.image)" class="ec-qty-product__img" [src]="getProductData(product.product_id)?.isSubscriptionPlan ? getSubscriptionImage(product.product_id, product.quantity) : getProductData(product.product_id)?.image" />
                      <div class="ec-qty-product__meta">
                        <div class="ec-qty-product__name">
                          <ng-container *ngIf="getProductData(product.product_id)?.isSubscriptionPlan; else defaultProductName">
                            {{ getSubscriptionSelectedName(product.product_id, product.quantity) }}
                          </ng-container>
                          <ng-template #defaultProductName>
                            {{ getProductData(product.product_id)?.product_name }}
                          </ng-template>
                        </div>
                        <div class="ec-qty-product__price">
                          {{ (getProductData(product.product_id)?.isSubscriptionPlan
                                ? getSubscriptionPrice(product.product_id, product.quantity)
                                : getProductData(product.product_id)?.retail_price_per_item)
                            | currency : getProductData(product.product_id)?.currency
                                       : getProductData(product.product_id)?.currency_symbol + ' ' }}
                        </div>
                        <!-- The checkout page shows this row as unpurchasable, so
                             flag it here rather than only in the grid above. -->
                        <div class="ec-oos"
                          *ngIf="isOutOfStock(getProductData(product.product_id))">
                          {{ "Out of stock" | translate }}
                        </div>
                      </div>
                    </div>

                    <div class="ec-stepper ec-qty-cell--qty">
                      <button type="button" class="ec-stepper__btn" (click)="decQty(product.product_id)">
                        <i class="fi fi-rr-minus-small"></i>
                      </button>
                      <input class="ec-stepper__input" type="text" name="quantity"
                        [value]="product.quantity"
                        (change)="setExactQty(product.product_id, $event)" />
                      <button type="button" class="ec-stepper__btn" (click)="incQty(product.product_id)">
                        <i class="fi fi-rr-plus-small"></i>
                      </button>
                    </div>

                    <!-- Quantity Lock. Not a form control: the quantity it
                         locks lives on `selectedProducts`, not in the reactive
                         form. Hidden on TWTW, which keeps the legacy checkout
                         layout and does not offer the setting. -->
                    <button type="button" class="ec-qty-toggle ec-qty-cell--lock" *ngIf="!isTaiwanLocal"
                      [class.ec-qty-toggle--on]="isQuantityLocked(product.product_id)"
                      [attr.aria-pressed]="isQuantityLocked(product.product_id)"
                      [attr.title]="'Lock quantity' | translate"
                      [attr.aria-label]="'Lock quantity' | translate"
                      (click)="toggleQuantityLock(product.product_id)">
                      <i class="fi" [ngClass]="isQuantityLocked(product.product_id) ? 'fi-rr-lock' : 'fi-rr-unlock'"></i>
                      <span class="ec-qty-toggle__label">{{ "Lock" | translate }}</span>
                    </button>

                    <button type="button" class="ec-icon-btn ec-icon-btn--danger ec-qty-cell--extra"
                      (click)="removeSelectedProduct(product.product_id)"
                      [attr.title]="'Remove' | translate"
                      [attr.aria-label]="'Remove' | translate">
                      <i class="fi fi-rr-trash"></i>
                    </button>
                  </div>

                  <div class="ec-qty-row ec-qty-row--unavailable" *ngIf="!getProductData(product.product_id)">
                    <div class="ec-qty-product__name">
                      {{ "Product (ID: {0}) no longer available, kindly remove this product to continue updating the link"
                          | translate : [product.product_id] }}
                    </div>
                    <button type="button" class="ec-btn ec-btn--outline-danger"
                      (click)="removeSelectedProduct(product.product_id, product)">
                      <i class="fi fi-rr-trash"></i>
                      {{ "Remove" | translate }}
                    </button>
                  </div>
                </ng-container>
              </div>

              <div class="ec-empty" *ngIf="!selectedProducts.length">
                {{ "Select product to enable the setting" | translate }}
              </div>
            </ng-container>

            <ng-container *ngIf="quantityTab === 'pwp' && hasPwpEntries()">
              <div class="ec-note ec-note--icon">
                <i class="fi fi-rr-info"></i>
                <span>
                  {{ "The selected products come with a Purchase With Purchase (PWP) promotion. Set how many PWP products are pre-selected on the checkout page and whether customers can see them." | translate }}
                  {{ "A hidden PWP product with a quantity above 0 is still added to the order without being shown." | translate }}
                </span>
              </div>

              <div class="ec-qty-list ec-qty-grid">
                <div class="ec-qty-head" aria-hidden="true">
                  <span class="ec-qty-head__product">{{ "Product" | translate }}</span>
                  <span>{{ "Quantity" | translate }}</span>
                  <span>{{ "Lock" | translate }}</span>
                  <span>{{ "Show" | translate }}</span>
                </div>

                <ng-container *ngFor="let entry of getPwpEntries(); trackBy: trackPwpEntry">
                <div class="ec-qty-row"
                  [class.ec-qty-row--has-picks]="entry.pick_groups.length"
                  [class.is-hidden]="!isPwpVisible(entry)">
                  <div class="ec-qty-product">
                    <img class="ec-qty-product__img" [src]="entry.image" />
                    <div class="ec-qty-product__meta">
                      <div class="ec-qty-product__name">{{ entry.product_name }}</div>
                      <!-- Promotion, condition, price and the products that
                           unlock it, on one wrapping line. -->
                      <div class="ec-pwp-meta">
                        <span class="ec-pwp-tag">{{ entry.promotion_name }}</span>
                        <span class="ec-pwp-tag ec-pwp-tag--muted" *ngIf="entry.min_qty > 1">
                          {{ "Buy {0} or more" | translate : [entry.min_qty] }}
                        </span>
                        <span class="ec-pwp-meta__text">
                          <ng-container *ngIf="entry.price > 0; else pwpFree">
                            {{ entry.price | currency : entry.currency : entry.currency_symbol + ' ' }}
                          </ng-container>
                          <ng-template #pwpFree>{{ "Free" | translate }}</ng-template>
                          · {{ "With: {0}" | translate : [entry.trigger_names.join(', ')] }}
                        </span>
                      </div>
                      <!-- The promotion has a minimum the link does not start
                           with: the settings still apply, but only once the
                           customer raises the quantity on the checkout page. -->
                      <div class="ec-pwp-condition" *ngIf="!pwpMeetsCondition(entry)">
                        <i class="fi fi-rr-info"></i>
                        {{ "Offered on the checkout page once the customer has {0} of the product; this link starts with {1}." | translate : [entry.min_qty, entry.trigger_qty] }}
                      </div>
                    </div>
                  </div>

                  <div class="ec-stepper ec-qty-cell--qty">
                    <button type="button" class="ec-stepper__btn" (click)="decPwpQty(entry)">
                      <i class="fi fi-rr-minus-small"></i>
                    </button>
                    <input class="ec-stepper__input" type="text" name="pwp-quantity"
                      [value]="getPwpSetting(entry.promotion_id, entry.product_id).quantity"
                      (change)="setExactPwpQty(entry, $event)" />
                    <button type="button" class="ec-stepper__btn" (click)="incPwpQty(entry)">
                      <i class="fi fi-rr-plus-small"></i>
                    </button>
                  </div>

                  <!-- Quantity Lock, as on the product rows: the checkout
                       page shows the pre-selected quantity without − / +. -->
                  <button type="button" class="ec-qty-toggle ec-qty-cell--lock"
                    [class.ec-qty-toggle--on]="isPwpLocked(entry)"
                    [attr.aria-pressed]="isPwpLocked(entry)"
                    [attr.title]="'Lock quantity' | translate"
                    [attr.aria-label]="'Lock quantity' | translate"
                    (click)="togglePwpLocked(entry)">
                    <i class="fi" [ngClass]="isPwpLocked(entry) ? 'fi-rr-lock' : 'fi-rr-unlock'"></i>
                    <span class="ec-qty-toggle__label">{{ "Lock" | translate }}</span>
                  </button>

                  <!-- On = the checkout page shows the PWP row. -->
                  <button type="button" class="ec-qty-toggle ec-qty-cell--extra"
                    [class.ec-qty-toggle--on]="isPwpVisible(entry)"
                    [attr.aria-pressed]="isPwpVisible(entry)"
                    [attr.title]="(isPwpVisible(entry) ? 'Show on checkout' : 'Hidden on checkout') | translate"
                    [attr.aria-label]="'Show on checkout' | translate"
                    (click)="togglePwpVisible(entry)">
                    <i class="fi" [ngClass]="isPwpVisible(entry) ? 'fi-rr-eye' : 'fi-rr-eye-crossed'"></i>
                    <span class="ec-qty-toggle__label">{{ "Show" | translate }}</span>
                  </button>
                </div>

                  <!-- Pick products: the groups of a bundled PWP product the
                       customer chooses from, nested under their PWP row. Per
                       option, how many the checkout page picks up front and
                       whether the option is offered. -->
                  <div class="ec-pwp-picks" *ngIf="entry.pick_groups.length">
                    <div class="ec-pwp-picks__group" *ngFor="let group of entry.pick_groups; trackBy: trackPwpGroup">
                      <div class="ec-pwp-picks__head">
                        <span class="ec-pwp-picks__title">
                          {{ "Pick {0} of the following option:" | translate : [pwpPickLimit(entry, group)] }}
                        </span>
                        <span class="ec-pwp-picks__count"
                          [class.is-full]="pwpPickCount(entry, group) >= pwpPickLimit(entry, group)">
                          {{ pwpPickCount(entry, group) }}/{{ pwpPickLimit(entry, group) }}
                        </span>
                      </div>
                      <div class="ec-helper ec-pwp-picks__hint" *ngIf="!pwpPickLimit(entry, group)">
                        {{ "Set the PWP product quantity above to pick options up front. Hidden options are never offered." | translate }}
                      </div>

                      <div class="ec-qty-row ec-qty-row--pick"
                        *ngFor="let pick of group.products; trackBy: trackPwpPick"
                        [class.is-hidden]="!isPwpPickVisible(entry, pick.product_id)">
                        <div class="ec-qty-product">
                          <img class="ec-qty-product__img" [src]="pick.image" />
                          <div class="ec-qty-product__meta">
                            <div class="ec-qty-product__name">{{ pick.product_name }}</div>
                          </div>
                        </div>

                        <div class="ec-stepper ec-qty-cell--qty">
                          <button type="button" class="ec-stepper__btn"
                            (click)="decPwpPickQty(entry, group, pick.product_id)">
                            <i class="fi fi-rr-minus-small"></i>
                          </button>
                          <input class="ec-stepper__input" type="text" name="pwp-pick-quantity"
                            [value]="getPwpPickSetting(entry, pick.product_id).quantity"
                            (change)="setExactPwpPickQty(entry, group, pick.product_id, $event)" />
                          <button type="button" class="ec-stepper__btn"
                            (click)="incPwpPickQty(entry, group, pick.product_id)">
                            <i class="fi fi-rr-plus-small"></i>
                          </button>
                        </div>

                        <button type="button" class="ec-qty-toggle ec-qty-cell--lock"
                          [class.ec-qty-toggle--on]="isPwpPickLocked(entry, pick.product_id)"
                          [attr.aria-pressed]="isPwpPickLocked(entry, pick.product_id)"
                          [attr.title]="'Lock quantity' | translate"
                          [attr.aria-label]="'Lock quantity' | translate"
                          (click)="togglePwpPickLocked(entry, pick.product_id)">
                          <i class="fi" [ngClass]="isPwpPickLocked(entry, pick.product_id) ? 'fi-rr-lock' : 'fi-rr-unlock'"></i>
                          <span class="ec-qty-toggle__label">{{ "Lock" | translate }}</span>
                        </button>

                        <button type="button" class="ec-qty-toggle ec-qty-cell--extra"
                          [class.ec-qty-toggle--on]="isPwpPickVisible(entry, pick.product_id)"
                          [attr.aria-pressed]="isPwpPickVisible(entry, pick.product_id)"
                          [attr.title]="(isPwpPickVisible(entry, pick.product_id) ? 'Show on checkout' : 'Hidden on checkout') | translate"
                          [attr.aria-label]="'Show on checkout' | translate"
                          (click)="togglePwpPickVisible(entry, pick.product_id)">
                          <i class="fi" [ngClass]="isPwpPickVisible(entry, pick.product_id) ? 'fi-rr-eye' : 'fi-rr-eye-crossed'"></i>
                          <span class="ec-qty-toggle__label">{{ "Show" | translate }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </section>

        <!-- Product Recommendations (hidden for the Taiwan TWTW store) -->
        <section class="ec-card" *ngIf="!isTaiwanLocal">
          <header class="ec-card__header">
            <span class="ec-card__icon">
              <i class="fi fi-rr-sparkles"></i>
            </span>
            <h2 class="ec-card__title">{{ "Product Recommendations" | translate }}</h2>
          </header>

          <div class="ec-card__body">
            <div class="ec-note">
              {{ "Increase sales by displaying additional products your customers can add to their cart." | translate }}
            </div>

            <label class="ec-toggle-row">
              <span class="ec-switch">
                <input type="checkbox" formControlName="product_recommendations" />
                <span class="ec-switch__track"></span>
              </span>
              <span class="ec-toggle-row__text">
                <span class="ec-label">{{ "Enable Product Recommendations" | translate }}</span>
                <span class="ec-helper">{{ "When enabled, customers will see recommended products that they can add to their cart." | translate }}</span>
              </span>
            </label>

            <!-- Mode: let the storefront suggest same-series products, or use a
                 hand-picked list. -->
            <div class="ec-radio-group" *ngIf="productRecommendationsEnabled">
              <label class="ec-radio-row"
                [class.is-active]="productRecommendationMode === RECOMMENDATION_MODE_AUTO">
                <input type="radio" class="ec-radio-row__input"
                  formControlName="product_recommendations_mode"
                  [value]="RECOMMENDATION_MODE_AUTO" />
                <span class="ec-radio-row__dot" aria-hidden="true"></span>
                <span class="ec-radio-row__label">
                  {{ "Auto-select recommended products from the same series" | translate }}
                </span>
              </label>

              <label class="ec-radio-row"
                [class.is-active]="productRecommendationMode === RECOMMENDATION_MODE_MANUAL">
                <input type="radio" class="ec-radio-row__input"
                  formControlName="product_recommendations_mode"
                  [value]="RECOMMENDATION_MODE_MANUAL" />
                <span class="ec-radio-row__dot" aria-hidden="true"></span>
                <span class="ec-radio-row__label">
                  {{ "Manually pick recommended products" | translate }}
                </span>
              </label>
            </div>

            <!-- Hand-picked list — manual mode only. -->
            <div class="ec-reco" *ngIf="productRecommendationsEnabled && isManualRecommendation">
              <div class="ec-reco__head">
                <div class="ec-label">{{ "Recommended Products" | translate }}</div>
                <span class="ec-reco__count"
                  [class.is-full]="productRecommendations.length >= MAX_PRODUCT_RECOMMENDATIONS">
                  {{ productRecommendations.length }}/{{ MAX_PRODUCT_RECOMMENDATIONS }}
                </span>
              </div>

              <div class="ec-search">
                <i class="fi fi-rr-search ec-search__icon"></i>
                <input class="ec-search__input" type="text" name="recommendation-filter"
                  id="recommendation-filter" [value]="productRecommendationFilter"
                  (input)="recommendationFilterChanged($event)"
                  placeholder="{{ 'Search product by name...' | translate }}" />
              </div>

              <div class="ec-product-list" *ngIf="!loading">
                <div class="ec-product-grid" *ngIf="getRecommendationCandidates()?.length">
                  <button type="button" class="ec-product-card"
                    *ngFor="let item of getRecommendationCandidates()"
                    [class.selected]="isProductRecommended(item.p_id)"
                    [class.is-disabled]="isOutOfStock(item)
                      || (!isProductRecommended(item.p_id)
                          && productRecommendations.length >= MAX_PRODUCT_RECOMMENDATIONS)"
                    [class.is-oos]="isOutOfStock(item) && !isProductRecommended(item.p_id)"
                    (click)="recommendationClick(item.p_id)">
                    <div class="ec-product-card__media">
                      <span class="ec-product-card__flag"
                        #tooltip="matTooltip" [matTooltip]="getCountryName(item?.country_code)"
                        matTooltipPosition="above" matTooltipHideDelay="100">
                        <img [src]="getFlagImageURL(item?.country_code)" />
                      </span>
                      <img class="ec-product-card__img" [src]="item.image" />
                    </div>
                    <div class="ec-product-card__info">
                      <div class="ec-product-card__name">{{ item.product_name?.toLowerCase() }}</div>
                      <div class="ec-product-card__price">
                        {{ item.retail_price_per_item | currency : item.currency : item.currency_symbol + ' ' }}
                      </div>
                      <!-- Pickable, but the checkout page shows it as
                           unavailable — flagged so that isn't a surprise. -->
                      <div class="ec-oos" *ngIf="isOutOfStock(item)">
                        {{ "Out of stock" | translate }}
                      </div>
                    </div>
                    <div class="ec-product-card__radio" aria-hidden="true">
                      <span class="ec-product-card__radio-dot"></span>
                    </div>
                  </button>
                </div>

                <div class="ec-empty" *ngIf="!getRecommendationCandidates()?.length">
                  {{ "No product available to recommend." | translate }}
                </div>
              </div>

              <div class="ec-loading" *ngIf="loading">
                <mat-spinner [diameter]="40"></mat-spinner>
              </div>

              <div class="ec-qty-list" *ngIf="productRecommendations.length">
                <div class="ec-qty-row" *ngFor="let product of productRecommendations">
                  <div class="ec-qty-product">
                    <img class="ec-qty-product__img" [src]="getProductData(product.product_id)?.image" />
                    <div class="ec-qty-product__meta">
                      <div class="ec-qty-product__name">
                        {{ getProductData(product.product_id)?.product_name }}
                      </div>
                      <div class="ec-qty-product__price">
                        {{ getProductData(product.product_id)?.retail_price_per_item
                          | currency : getProductData(product.product_id)?.currency
                                     : getProductData(product.product_id)?.currency_symbol + ' ' }}
                      </div>
                      <div class="ec-oos"
                        *ngIf="isOutOfStock(getProductData(product.product_id))">
                        {{ "Out of stock" | translate }}
                      </div>
                    </div>
                  </div>

                  <div class="ec-qty-actions">
                    <div class="ec-stepper">
                      <button type="button" class="ec-stepper__btn"
                        (click)="decRecommendationQty(product.product_id)">
                        <i class="fi fi-rr-minus-small"></i>
                      </button>
                      <input class="ec-stepper__input" type="text" name="recommendation-quantity"
                        [value]="product.quantity"
                        (change)="setExactRecommendationQty(product.product_id, $event)" />
                      <button type="button" class="ec-stepper__btn"
                        (click)="incRecommendationQty(product.product_id)">
                        <i class="fi fi-rr-plus-small"></i>
                      </button>
                    </div>
                    <button type="button" class="ec-icon-btn ec-icon-btn--danger"
                      (click)="removeRecommendation(product.product_id)"
                      aria-label="Remove">
                      <i class="fi fi-rr-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Voucher Code -->
        <section class="ec-card ec-card--voucher">
          <header class="ec-card__header ec-voucher-row">
            <span class="ec-card__icon">
              <i class="fi fi-rr-ticket"></i>
            </span>
            <div class="ec-card__header-content">
              <div class="ec-voucher-title-wrap">
                <h2 class="ec-card__title">{{ "Voucher Code" | translate }}</h2>
                <span class="ec-voucher-badge" [class.is-active]="generateForm.get('voucher_status')?.value">
                  {{ (generateForm.get('voucher_status')?.value ? 'Active' : 'Disabled') | translate }}
                </span>
              </div>
              <span class="ec-card__subtitle">
                {{ "Allow customers to apply voucher codes during checkout" | translate }}
              </span>
            </div>
            <label class="ec-switch ml-auto" [title]="'Toggle voucher code' | translate">
              <input type="checkbox" formControlName="voucher_status" />
              <span class="ec-switch__track"></span>
            </label>
          </header>
        </section>

        <!-- Appearance -->
        <section class="ec-card ec-card--appearance">
          <header class="ec-card__header">
            <span class="ec-card__icon">
              <i class="fi fi-rr-palette"></i>
            </span>
            <div class="ec-card__header-content">
              <h2 class="ec-card__title">{{ "Appearance" | translate }}</h2>
              <span class="ec-card__subtitle" *ngIf="!isSplitPreview">
                {{ "Customize checkout brand colors and typography" | translate }}
              </span>
              <span class="ec-card__subtitle" *ngIf="isSplitPreview">
                {{ "Split theme active • payment button styling" | translate }}
              </span>
            </div>
          </header>

          <div class="ec-card__body">
            <!-- Split checkout notice (compact banner) -->
            <div class="ec-appearance-alert" *ngIf="isSplitPreview">
              <i class="fi fi-rr-info"></i>
              <span>{{ "The Split checkout theme uses your own header, so only the payment button color applies here." | translate }}</span>
            </div>

            <!-- Quick Theme Palettes (1-click color harmony) -->
            <div class="ec-appearance-presets" *ngIf="!isSplitPreview">
              <div class="ec-appearance-presets__label">
                <i class="fi fi-rr-magic-wand"></i>
                <span>{{ "Quick Palettes" | translate }}:</span>
              </div>
              <div class="ec-appearance-presets__list">
                <button
                  type="button"
                  class="ec-preset-chip"
                  *ngFor="let preset of colorPresets"
                  [class.active]="isColorPresetActive(preset)"
                  (click)="applyColorPreset(preset)"
                  [title]="preset.name"
                >
                  <span class="ec-preset-chip__dots">
                    <span class="ec-preset-chip__dot" [style.background-color]="preset.preview[0]"></span>
                    <span class="ec-preset-chip__dot" [style.background-color]="preset.preview[1]"></span>
                  </span>
                  <span class="ec-preset-chip__name">{{ preset.name | translate }}</span>
                  <i class="fi fi-rr-check ec-preset-chip__check" *ngIf="isColorPresetActive(preset)"></i>
                </button>
              </div>
            </div>

            <!-- Modern 2-Column Color Cards Grid -->
            <div class="ec-appearance-grid" [class.ec-appearance-grid--single]="isSplitPreview">
              <div class="ec-color-card" *ngFor="let appearanceOption of visibleAppearanceOptions">
                <div class="ec-color-card__header">
                  <span class="ec-color-card__title">{{ appearanceOption.title | translate }}</span>

                  <!-- Interactive Live Hex Pill & Custom Picker Trigger -->
                  <label class="ec-color-card__hex-pill" [title]="'Custom color' | translate">
                    <span
                      class="ec-color-card__hex-dot"
                      [style.background-color]="getCurrentColor(appearanceOption)"
                      [class.is-light]="isLightColor(getCurrentColor(appearanceOption))"
                    ></span>
                    <span class="ec-color-card__hex-val">
                      {{ (getCurrentColor(appearanceOption) || '#------') | uppercase }}
                    </span>
                    <input
                      type="color"
                      class="ec-color-card__native-input"
                      [value]="getCurrentColor(appearanceOption)"
                      (change)="onChangeColor($event, appearanceOption.formName)"
                    />
                  </label>
                </div>

                <div class="ec-color-card__swatches">
                  <button
                    type="button"
                    class="ec-swatch"
                    *ngFor="let colorOption of appearanceOption.colorOptions"
                    [class.active]="isColorActive(appearanceOption, colorOption)"
                    [class.is-light]="isLightColor(colorOption)"
                    [style.background-color]="colorOption"
                    (click)="selectAppearanceColor(appearanceOption, colorOption)"
                    [title]="colorOption"
                  >
                    <svg
                      *ngIf="isColorActive(appearanceOption, colorOption)"
                      class="ec-swatch__check"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path d="M2.5 6.2L4.8 8.5L9.5 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>

                  <!-- Custom Swatch (+) -->
                  <label
                    class="ec-swatch ec-swatch--custom"
                    [class.active]="isCustomColor(appearanceOption)"
                    [class.is-light]="isLightColor(getCurrentColor(appearanceOption))"
                    [style.background-color]="isCustomColor(appearanceOption) ? getCurrentColor(appearanceOption) : ''"
                    [title]="'Custom color' | translate"
                  >
                    <span class="ec-swatch__plus" *ngIf="!isCustomColor(appearanceOption)">+</span>
                    <svg
                      *ngIf="isCustomColor(appearanceOption)"
                      class="ec-swatch__check"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path d="M2.5 6.2L4.8 8.5L9.5 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <input
                      type="color"
                      class="ec-color-card__native-input"
                      (change)="onChangeColor($event, appearanceOption.formName)"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Custom HTML Content (Tabs: Custom Header, Custom Highlight, Custom Note, Custom Footer) -->
        <section class="ec-card ec-card--custom-tabs">
          <header class="ec-card__header">
            <span class="ec-card__icon">
              <i class="fi fi-rr-comment-code"></i>
            </span>
            <div class="ec-card__header-content">
              <h2 class="ec-card__title">{{ "Custom HTML Content" | translate }}</h2>
            </div>
          </header>

          <div class="ec-card__body">
            <!-- Modern Responsive Tab Bar -->
            <div class="ec-custom-tabs" role="tablist" aria-label="Custom HTML Content Tabs">
              <!-- Tab 1: Custom Header -->
              <button type="button" class="ec-custom-tab"
                role="tab"
                id="tab-custom-header"
                aria-controls="panel-custom-header"
                [attr.aria-selected]="currentCustomTab === 'header'"
                [class.active]="currentCustomTab === 'header'"
                (click)="selectCustomTab('header')">
                <i class="fi fi-rr-browser ec-custom-tab__icon"></i>
                <span class="ec-custom-tab__label">{{ "Custom Header" | translate }}</span>
                <span class="ec-custom-tab__dot"
                  [class.is-active]="isCustomBlockActive('header')"
                  [attr.title]="(isCustomBlockActive('header') ? 'Active' : 'Inactive') | translate"></span>
              </button>

              <!-- Tab 2: Custom Highlight (hidden for Taiwan stores) -->
              <button type="button" class="ec-custom-tab"
                role="tab"
                id="tab-custom-highlight"
                aria-controls="panel-custom-highlight"
                *ngIf="!isTaiwan"
                [attr.aria-selected]="currentCustomTab === 'highlight'"
                [class.active]="currentCustomTab === 'highlight'"
                (click)="selectCustomTab('highlight')">
                <i class="fi fi-rr-sparkles ec-custom-tab__icon"></i>
                <span class="ec-custom-tab__label">{{ "Custom Highlight" | translate }}</span>
                <span class="ec-custom-tab__dot"
                  [class.is-active]="isCustomBlockActive('highlight')"
                  [attr.title]="(isCustomBlockActive('highlight') ? 'Active' : 'Inactive') | translate"></span>
              </button>

              <!-- Tab 3: Custom Note (hidden for Taiwan stores) -->
              <button type="button" class="ec-custom-tab"
                role="tab"
                id="tab-custom-note"
                aria-controls="panel-custom-note"
                *ngIf="!isTaiwan"
                [attr.aria-selected]="currentCustomTab === 'note'"
                [class.active]="currentCustomTab === 'note'"
                (click)="selectCustomTab('note')">
                <i class="fi fi-rr-document ec-custom-tab__icon"></i>
                <span class="ec-custom-tab__label">{{ "Custom Note" | translate }}</span>
                <span class="ec-custom-tab__dot"
                  [class.is-active]="isCustomBlockActive('note')"
                  [attr.title]="(isCustomBlockActive('note') ? 'Active' : 'Inactive') | translate"></span>
              </button>

              <!-- Tab 4: Custom Footer -->
              <button type="button" class="ec-custom-tab"
                role="tab"
                id="tab-custom-footer"
                aria-controls="panel-custom-footer"
                [attr.aria-selected]="currentCustomTab === 'footer'"
                [class.active]="currentCustomTab === 'footer'"
                (click)="selectCustomTab('footer')">
                <i class="fi fi-rr-layout-fluid ec-custom-tab__icon"></i>
                <span class="ec-custom-tab__label">{{ "Custom Footer" | translate }}</span>
                <span class="ec-custom-tab__dot"
                  [class.is-active]="isCustomBlockActive('footer')"
                  [attr.title]="(isCustomBlockActive('footer') ? 'Active' : 'Inactive') | translate"></span>
              </button>
            </div>

            <!-- Tab Panels -->
            <!-- 1. Custom Header -->
            <div class="ec-custom-tab-panel"
              id="panel-custom-header"
              role="tabpanel"
              aria-labelledby="tab-custom-header"
              *ngIf="currentCustomTab === 'header'">
              <div class="ec-note">
                {{ "Hide the default header and craft your own using custom HTML for a fully branded checkout experience." | translate }}
              </div>

              <label class="ec-toggle-row" [class.ec-toggle-row--locked]="isSplitCheckoutTheme">
                <span class="ec-switch">
                  <input type="checkbox" formControlName="custom_header_enabled" />
                  <span class="ec-switch__track"></span>
                </span>
                <span class="ec-toggle-row__text">
                  <span class="ec-label">{{ "Hide default header" | translate }}</span>
                  <span class="ec-helper" *ngIf="!isSplitCheckoutTheme">{{ "Turn off the built-in blue header to use your own design." | translate }}</span>
                  <span class="ec-helper" *ngIf="isSplitCheckoutTheme">{{ "Always on for the Split checkout theme, which shows your header across the top of the page. Change your theme in Preferences > Appearance > Checkout." | translate }}</span>
                </span>
              </label>

              <div class="ec-custom-header-editor"
                [class.ec-custom-header-editor--disabled]="!generateForm.get('custom_header_enabled')?.value">
                <div class="ec-custom-header-editor__head">
                  <label class="ec-label" for="custom_header_html">{{ "Custom header HTML" | translate }}</label>
                  <div class="ec-custom-header-editor__actions">
                    <button type="button" class="ec-reset-btn" (click)="resetCustomHeaderHtml()">
                      {{ "Reset to sample" | translate }}
                    </button>
                    <button type="button" class="ec-expand-btn"
                      (click)="openHtmlPopup('header', $event.currentTarget)"
                      [attr.aria-label]="'Expand' | translate" title="{{ 'Expand' | translate }}">
                      <i class="fi fi-rr-expand"></i>
                      <span class="ec-expand-btn__text">{{ "Expand" | translate }}</span>
                    </button>
                  </div>
                </div>
                <textarea id="custom_header_html" class="ec-textarea ec-textarea--code"
                  formControlName="custom_header_html" spellcheck="false"
                  placeholder="{{ '<div style=&quot;padding:24px&quot;>Your header</div>' | translate }}"></textarea>
                <p class="ec-helper">
                  {{ "Inline styles are supported. Your HTML renders in place of the default header in the live preview." | translate }}
                </p>
              </div>
            </div>

            <!-- 2. Custom Highlight (not offered for Taiwan stores) -->
            <div class="ec-custom-tab-panel"
              id="panel-custom-highlight"
              role="tabpanel"
              aria-labelledby="tab-custom-highlight"
              *ngIf="!isTaiwan && currentCustomTab === 'highlight'">
              <div class="ec-note">
                {{ "Spell out what a custom programme includes with your own HTML block, shown on the checkout page just above the voucher field." | translate }}
              </div>

              <label class="ec-toggle-row">
                <span class="ec-switch">
                  <input type="checkbox" formControlName="custom_highlight_enabled" />
                  <span class="ec-switch__track"></span>
                </span>
                <span class="ec-toggle-row__text">
                  <span class="ec-label">{{ "Show custom highlight" | translate }}</span>
                  <span class="ec-helper">{{ "Off by default. Turn it on to add your block above the voucher field on the checkout page." | translate }}</span>
                </span>
              </label>

              <div class="ec-custom-header-editor"
                [class.ec-custom-header-editor--disabled]="!generateForm.get('custom_highlight_enabled')?.value">
                <div class="ec-custom-header-editor__head">
                  <label class="ec-label" for="custom_highlight_html">{{ "Custom highlight HTML" | translate }}</label>
                  <div class="ec-custom-header-editor__actions">
                    <button type="button" class="ec-reset-btn" (click)="resetCustomHighlightHtml()">
                      {{ "Reset to sample" | translate }}
                    </button>
                    <button type="button" class="ec-expand-btn"
                      (click)="openHtmlPopup('highlight', $event.currentTarget)"
                      [attr.aria-label]="'Expand' | translate" title="{{ 'Expand' | translate }}">
                      <i class="fi fi-rr-expand"></i>
                      <span class="ec-expand-btn__text">{{ "Expand" | translate }}</span>
                    </button>
                  </div>
                </div>
                <textarea id="custom_highlight_html" class="ec-textarea ec-textarea--code"
                  formControlName="custom_highlight_html" spellcheck="false"
                  placeholder="{{ '<div style=&quot;padding:24px&quot;>Your highlight</div>' | translate }}"></textarea>
                <p class="ec-helper">
                  {{ "Inline styles are supported. Your HTML renders above the voucher field in the live preview and on the checkout page." | translate }}
                </p>
              </div>
            </div>

            <!-- 3. Custom Note (not offered for Taiwan stores) -->
            <div class="ec-custom-tab-panel"
              id="panel-custom-note"
              role="tabpanel"
              aria-labelledby="tab-custom-note"
              *ngIf="!isTaiwan && currentCustomTab === 'note'">
              <div class="ec-note">
                {{ "Tell the customer what happens next with your own HTML block, shown on the checkout page under the order total." | translate }}
              </div>

              <label class="ec-toggle-row">
                <span class="ec-switch">
                  <input type="checkbox" formControlName="custom_note_enabled" />
                  <span class="ec-switch__track"></span>
                </span>
                <span class="ec-toggle-row__text">
                  <span class="ec-label">{{ "Show custom note" | translate }}</span>
                  <span class="ec-helper">{{ "Off by default. Turn it on to add your block under the order total on the checkout page." | translate }}</span>
                </span>
              </label>

              <div class="ec-custom-header-editor"
                [class.ec-custom-header-editor--disabled]="!generateForm.get('custom_note_enabled')?.value">
                <div class="ec-custom-header-editor__head">
                  <label class="ec-label" for="custom_note_html">{{ "Custom note HTML" | translate }}</label>
                  <div class="ec-custom-header-editor__actions">
                    <button type="button" class="ec-reset-btn" (click)="resetCustomNoteHtml()">
                      {{ "Reset to sample" | translate }}
                    </button>
                    <button type="button" class="ec-expand-btn"
                      (click)="openHtmlPopup('note', $event.currentTarget)"
                      [attr.aria-label]="'Expand' | translate" title="{{ 'Expand' | translate }}">
                      <i class="fi fi-rr-expand"></i>
                      <span class="ec-expand-btn__text">{{ "Expand" | translate }}</span>
                    </button>
                  </div>
                </div>
                <textarea id="custom_note_html" class="ec-textarea ec-textarea--code"
                  formControlName="custom_note_html" spellcheck="false"
                  placeholder="{{ '<div style=&quot;padding:24px&quot;>Your note</div>' | translate }}"></textarea>
                <p class="ec-helper">
                  {{ "Inline styles are supported. Your HTML renders under the order total — in its own card on the classic checkout theme." | translate }}
                </p>
              </div>
            </div>

            <!-- 4. Custom Footer -->
            <div class="ec-custom-tab-panel"
              id="panel-custom-footer"
              role="tabpanel"
              aria-labelledby="tab-custom-footer"
              *ngIf="currentCustomTab === 'footer'">
              <div class="ec-note">
                {{ "Add a custom HTML footer below the checkout for extra info, trust badges, or support links." | translate }}
              </div>

              <label class="ec-toggle-row">
                <span class="ec-switch">
                  <input type="checkbox" formControlName="custom_footer_enabled" />
                  <span class="ec-switch__track"></span>
                </span>
                <span class="ec-toggle-row__text">
                  <span class="ec-label">{{ "Show custom footer" | translate }}</span>
                  <span class="ec-helper">{{ "Off by default. Turn it on to add your custom footer below the checkout page." | translate }}</span>
                </span>
              </label>

              <div class="ec-custom-header-editor"
                [class.ec-custom-header-editor--disabled]="!generateForm.get('custom_footer_enabled')?.value">
                <div class="ec-custom-header-editor__head">
                  <label class="ec-label" for="custom_footer_html">{{ "Custom footer HTML" | translate }}</label>
                  <div class="ec-custom-header-editor__actions">
                    <button type="button" class="ec-reset-btn" (click)="resetCustomFooterHtml()">
                      {{ "Reset to sample" | translate }}
                    </button>
                    <button type="button" class="ec-reset-btn" (click)="clearCustomFooterHtml()"
                      *ngIf="hasCustomFooterContent">
                      {{ "Clear" | translate }}
                    </button>
                    <button type="button" class="ec-expand-btn"
                      (click)="openHtmlPopup('footer', $event.currentTarget)"
                      [attr.aria-label]="'Expand' | translate" title="{{ 'Expand' | translate }}">
                      <i class="fi fi-rr-expand"></i>
                      <span class="ec-expand-btn__text">{{ "Expand" | translate }}</span>
                    </button>
                  </div>
                </div>
                <textarea id="custom_footer_html" class="ec-textarea ec-textarea--code"
                  formControlName="custom_footer_html" spellcheck="false"
                  placeholder="{{ '<div style=&quot;padding:24px&quot;>Your footer</div>' | translate }}"></textarea>
                <p class="ec-helper">
                  {{ "Inline styles are supported. Leave blank to show nothing — your HTML always renders below the terms and e-invoice option in the live preview." | translate }}
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- RIGHT: Live Customer Preview -->
      <aside class="ec-grid__right">
        <div class="ec-preview">
          <div class="ec-preview__label">{{ "LIVE CUSTOMER PREVIEW" | translate }}</div>
          <div class="ec-preview__note" *ngIf="!isTaiwanLocal">
            <i class="fi fi-rr-info"></i>
            {{ "This preview shows the checkout page only — other promotions and the product link domain aren't reflected here." | translate }}
          </div>
          <div class="ec-preview__note" *ngIf="isTaiwanLocal">
            <i class="fi fi-rr-info"></i>
            {{ "Promotions won't be shown in this preview." | translate }}
          </div>
          <div class="ec-preview__note" *ngIf="isSplitPreview">
            <i class="fi fi-rr-info"></i>
            {{ "Split checkout theme. The order summary is shown open here so you can see your products — on the page it starts closed, behind the bar." | translate }}
          </div>
          <div class="ec-phone" [class.ec-phone--tw]="isTaiwan">
            <div class="ec-phone__screen">
              <!-- Hero / page header. Under the split theme both are replaced
                   by the full-bleed band inside .ec-split. -->
              <div class="ec-phone__custom-header"
                *ngIf="!isSplitPreview && generateForm.get('custom_header_enabled')?.value"
                [innerHTML]="getSafeCustomHeaderHtml()"></div>

              <div class="ec-phone__hero"
                *ngIf="!isSplitPreview && !generateForm.get('custom_header_enabled')?.value"
                [ngStyle]="{
                  'background-color': generateForm.get('design_header_section_color')?.value || '#45489D'
                }">
                <h3 class="ec-phone__hero-title"
                  [ngStyle]="{
                    'color': generateForm.get('design_main_title_color')?.value || '#ffffff'
                  }">
                  {{ generateForm.get('page_title')?.value || ('Your page title' | translate) }}
                </h3>
                <p class="ec-phone__hero-desc"
                  *ngIf="generateForm.get('description')?.value"
                  [ngStyle]="{
                    'color': generateForm.get('design_sub_text_color')?.value || '#ffffff'
                  }">
                  {{ generateForm.get('description')?.value }}
                </p>
              </div>

              <!-- ============ TAIWAN LAYOUT ============ -->
              <ng-container *ngIf="isTaiwan">
                <!-- Pink summary card: Your Order + Payment Method + E-Invoice -->
                <div class="ec-phone__summary">
                  <!-- Your Order -->
                  <div class="ec-phone__sec">
                    <h4 class="ec-phone__sec-title">{{ "Your Order" | translate }}</h4>
                    <div class="ec-phone__white-card">
                      <div class="ec-phone__products-label">{{ "Product/s:" | translate }}</div>
                      <div class="ec-phone__product-list" *ngIf="selectedProducts.length">
                        <ng-container *ngFor="let product of selectedProducts">
                          <div class="ec-phone__product" *ngIf="getProductData(product.product_id) as p">
                            <img class="ec-phone__product-img" [src]="p.isSubscriptionPlan ? getSubscriptionImage(product.product_id, product.quantity) : p.image" />
                            <div class="ec-phone__product-meta">
                              <div class="ec-phone__product-name">{{ p.isSubscriptionPlan ? getSubscriptionSelectedName(product.product_id, product.quantity) : p.product_name }}</div>
                              <div class="ec-phone__product-price">
                                {{ (p.isSubscriptionPlan ? getSubscriptionPrice(product.product_id, product.quantity) : p.retail_price_per_item) | currency : p.currency : p.currency_symbol + ' ' }}
                              </div>
                            </div>
                            <!-- Quantity Lock: the checkout page drops the − / + for a
                                 locked product and shows the fixed quantity alone. -->
                            <div class="ec-phone__qty"
                              [class.ec-phone__qty--locked]="isQuantityLocked(product.product_id)">
                              <span class="ec-phone__qty-btn"
                                *ngIf="!isQuantityLocked(product.product_id)">−</span>
                              <span class="ec-phone__qty-value">{{ product.quantity }}</span>
                              <span class="ec-phone__qty-btn"
                                *ngIf="!isQuantityLocked(product.product_id)">+</span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <div class="ec-phone__empty" *ngIf="!selectedProducts.length">
                        {{ "Select products from the left to preview" | translate }}
                      </div>
                      <div class="ec-phone__total" *ngIf="selectedProducts.length">
                        <span class="ec-phone__total-label">{{ "Total" | translate }}</span>
                        <span class="ec-phone__total-amount">
                          {{ phonePreviewTotal | currency : phonePreviewCurrency : phonePreviewCurrencySymbol + ' ' }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Payment Method -->
                  <div class="ec-phone__sec">
                    <h4 class="ec-phone__sec-title">{{ "Payment Method" | translate }}</h4>
                    <div class="ec-phone__pay-list">
                      <ng-container *ngFor="let method of twPaymentMethods; let first = first">
                        <div class="ec-phone__pay-option" [class.ec-phone__pay-option--open]="first">
                          <div class="ec-phone__pay-option-head" *ngIf="first">
                            <span class="ec-phone__pay-option-title">
                              <i class="fi {{ method.icon }}"></i>{{ method.label | translate }}
                            </span>
                            <span class="ec-phone__pay-toggle">−</span>
                          </div>
                          <ng-container *ngIf="!first">
                            <span class="ec-phone__pay-option-title">
                              <i class="fi {{ method.icon }}"></i>{{ method.label | translate }}
                            </span>
                            <span class="ec-phone__pay-toggle">+</span>
                          </ng-container>
                          <div class="ec-phone__pay-option-body" *ngIf="first">
                            <span class="ec-phone__radio ec-phone__radio--on"></span>
                            <span>{{ method.label | translate }}</span>
                          </div>
                        </div>
                      </ng-container>
                      <div class="ec-phone__empty" *ngIf="!twPaymentMethods.length">
                        {{ "No payment method available" | translate }}
                      </div>
                    </div>
                  </div>

                  <!-- E-Invoice -->
                  <div class="ec-phone__sec">
                    <h4 class="ec-phone__sec-title">{{ "E-Invoice" | translate }}</h4>
                    <label class="ec-phone__invoice-radio ec-phone__invoice-radio--checked">
                      <span class="ec-phone__radio ec-phone__radio--on"></span>
                      {{ "Personal" | translate }}
                    </label>
                    <div class="ec-phone__invoice-sub">
                      <div class="ec-phone__invoice-types">
                        <label class="ec-phone__invoice-radio ec-phone__invoice-radio--checked">
                          <span class="ec-phone__radio ec-phone__radio--on"></span>
                          {{ "Email" | translate }}
                        </label>
                        <label class="ec-phone__invoice-radio">
                          <span class="ec-phone__radio"></span>
                          {{ "Mobile Carrier" | translate }}
                        </label>
                      </div>
                      <div class="ec-phone__field">
                        <label class="ec-phone__field-label required">{{ "Email" | translate }}</label>
                        <input class="ec-phone__field-input" type="text" disabled placeholder="{{ 'Email' | translate }}" />
                      </div>
                    </div>
                    <label class="ec-phone__invoice-radio">
                      <span class="ec-phone__radio"></span>
                      {{ "Company" | translate }}
                    </label>
                  </div>
                </div>

                <!-- Personal Details (on white page, NOT in the pink card) -->
                <div class="ec-phone__details ec-phone__details--plain">
                  <h4 class="ec-phone__details-title">{{ "Personal Details" | translate }}</h4>
                  <div class="ec-phone__details-body">
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">{{ "Full name" | translate }}</label>
                      <input class="ec-phone__field-input" type="text" disabled placeholder="{{ 'Full name' | translate }}" />
                    </div>
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">{{ "Email" | translate }}</label>
                      <input class="ec-phone__field-input" type="text" disabled placeholder="{{ 'Email address' | translate }}" />
                    </div>
                    <div class="ec-phone__field ec-phone__field--readonly">
                      <label class="ec-phone__field-label">{{ "Phone Code" | translate }}</label>
                      <div class="ec-phone__phone-code-center">{{ getPhoneCode(filteredCountry) }}</div>
                    </div>
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">
                        {{ "Phone" | translate }}
                        <i class="fi fi-rr-info ec-phone__field-info"></i>
                      </label>
                      <input class="ec-phone__field-input" type="text" disabled placeholder="{{ 'Phone' | translate }}" />
                    </div>
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">{{ "City" | translate }}</label>
                      <button type="button" class="ec-phone__field-select" disabled>
                        <i class="fi fi-rr-angle-small-down"></i>
                      </button>
                    </div>
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">{{ "District" | translate }}</label>
                      <button type="button" class="ec-phone__field-select" disabled>
                        <i class="fi fi-rr-angle-small-down"></i>
                      </button>
                    </div>
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">{{ "Postcode" | translate }}</label>
                      <input class="ec-phone__field-input" type="text" disabled placeholder="{{ 'Postcode' | translate }}" />
                    </div>
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">{{ "Address" | translate }}</label>
                      <textarea class="ec-phone__field-input ec-phone__field-textarea" disabled
                        placeholder="{{ 'Address' | translate }}"></textarea>
                    </div>
                    <!-- No Custom Highlight block: this layout is only drawn for
                         the Taiwan stores, which the feature skips. -->
                    <div class="ec-phone__voucher" *ngIf="showVoucherCode">
                      <label class="ec-phone__voucher-label">{{ "Enter your voucher code" | translate }}</label>
                      <div class="ec-phone__voucher-row">
                        <input class="ec-phone__voucher-input" type="text" disabled
                          placeholder="{{ 'Voucher' | translate }}" />
                        <button type="button" class="ec-phone__voucher-btn" disabled>
                          {{ "Apply" | translate }}
                        </button>
                      </div>
                    </div>
                    <button type="button" class="ec-phone__remark-btn" disabled>
                      + {{ "Add a remark" | translate }}
                      <span class="ec-phone__remark-opt">({{ "optional" | translate }})</span>
                    </button>
                    <div class="ec-phone__notice">
                      {{ "Please enter your shipping address to see the available delivery service." | translate }}
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- ============ DEFAULT LAYOUT (non-Taiwan, classic) ============ -->
              <ng-container *ngIf="!isTaiwan && !isSplitPreview">
                <!-- Order card -->
                <div class="ec-phone__order">
                  <h4 class="ec-phone__order-title">{{ "Your Order" | translate }}</h4>
                  <div class="ec-phone__products">
                    <div class="ec-phone__products-label">{{ "Product/s:" | translate }}</div>
                    <div class="ec-phone__product-list" *ngIf="selectedProducts.length">
                      <ng-container *ngFor="let product of selectedProducts">
                        <div class="ec-phone__product" *ngIf="getProductData(product.product_id) as p">
                          <img class="ec-phone__product-img" [src]="p.isSubscriptionPlan ? getSubscriptionImage(product.product_id, product.quantity) : p.image" />
                          <div class="ec-phone__product-meta">
                            <div class="ec-phone__product-name">{{ p.isSubscriptionPlan ? getSubscriptionSelectedName(product.product_id, product.quantity) : p.product_name }}</div>
                            <div class="ec-phone__product-price">
                              {{ (p.isSubscriptionPlan ? getSubscriptionPrice(product.product_id, product.quantity) : p.retail_price_per_item) | currency : p.currency : p.currency_symbol + ' ' }}
                            </div>
                          </div>
                          <!-- Quantity Lock: the checkout page drops the − / + for a
                               locked product and shows the fixed quantity alone. -->
                          <div class="ec-phone__qty"
                            [class.ec-phone__qty--locked]="isQuantityLocked(product.product_id)">
                            <span class="ec-phone__qty-btn"
                              *ngIf="!isQuantityLocked(product.product_id)">−</span>
                            <span class="ec-phone__qty-value">{{ product.quantity }}</span>
                            <span class="ec-phone__qty-btn"
                              *ngIf="!isQuantityLocked(product.product_id)">+</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="ec-phone__empty" *ngIf="!selectedProducts.length">
                      {{ "Select products from the left to preview" | translate }}
                    </div>

                    <!-- Recommended Add-ons — mirrors CheckoutRecommendedAddons,
                         which sits between the product list and the totals on
                         the real checkout page. Shown expanded here; on the
                         storefront the customer taps the header to open it. -->
                    <!-- Promotion — mirrors the PWP rows of the storefront's
                         Promotion section: the PWP products the selected
                         products unlock, at the quantity the link pre-selects,
                         with a bundle's offered picks beneath. Hidden rows and
                         hidden picks are left out, as the checkout page leaves
                         them out. Shown expanded; on the storefront the
                         customer taps the header to open it. -->
                    <div class="ec-phone__addons ec-phone__addons--promo" *ngIf="previewPwpRows.length">
                      <div class="ec-phone__addons-head">
                        <i class="fi fi-rr-gift"></i>
                        <span class="ec-phone__addons-title">{{ "Promotion" | translate }}</span>
                        <span class="ec-phone__addons-count">{{ previewPwpRows.length }}</span>
                        <i class="fi fi-rr-angle-small-up ec-phone__addons-chevron"></i>
                      </div>

                      <div class="ec-phone__addon-list">
                        <ng-container *ngFor="let row of previewPwpRows">
                          <div class="ec-phone__addon ec-phone__addon--pwp">
                            <img class="ec-phone__addon-img" [src]="row.image" />
                            <div class="ec-phone__addon-meta">
                              <div class="ec-phone__addon-name">{{ row.product_name }}</div>
                              <div class="ec-phone__addon-promo">{{ row.promotion_name }}</div>
                            </div>
                            <span class="ec-phone__addon-price ec-phone__addon-price--pwp">
                              <ng-container *ngIf="row.price > 0; else previewPwpFree">
                                {{ row.price | currency : row.currency : row.currency_symbol + ' ' }}
                              </ng-container>
                              <ng-template #previewPwpFree>{{ "Free" | translate }}</ng-template>
                            </span>
                            <!-- Quantity Lock drops the − / + here too. -->
                            <div class="ec-phone__qty ec-phone__qty--sm"
                              [class.ec-phone__qty--locked]="row.locked">
                              <span class="ec-phone__qty-btn" *ngIf="!row.locked">−</span>
                              <span class="ec-phone__qty-value">{{ row.quantity }}</span>
                              <span class="ec-phone__qty-btn" *ngIf="!row.locked">+</span>
                            </div>
                          </div>

                          <div class="ec-phone__picks" *ngFor="let group of row.pick_groups">
                            <div class="ec-phone__picks-head">
                              <span [innerHTML]="'Pick <strong>{0}</strong> of the following option:' | translate : [group.limit]"></span>
                              <span class="ec-phone__picks-count"
                                [class.ec-phone__picks-count--full]="group.limit > 0 && group.picked >= group.limit">
                                ({{ group.picked }}/{{ group.limit }})
                                <i class="fi fi-rr-angle-small-down"></i>
                              </span>
                            </div>
                            <div class="ec-phone__pick" *ngFor="let pick of group.products">
                              <img class="ec-phone__pick-img" [src]="pick.image" />
                              <span class="ec-phone__pick-name">{{ pick.product_name }}</span>
                              <span class="ec-phone__pick-qty">
                                <span class="ec-phone__pick-btn" *ngIf="!pick.locked">−</span>
                                <span class="ec-phone__pick-value">{{ pick.quantity }}</span>
                                <span class="ec-phone__pick-btn" *ngIf="!pick.locked">+</span>
                              </span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>

                    <div class="ec-phone__addons" *ngIf="productRecommendationsEnabled">
                      <div class="ec-phone__addons-head">
                        <i class="fi fi-rr-shopping-cart"></i>
                        <span class="ec-phone__addons-title">
                          {{ "Recommended Add-ons" | translate }}
                        </span>
                        <span class="ec-phone__addons-count" *ngIf="previewRecommendations.length">
                          {{ previewRecommendations.length }}
                        </span>
                      </div>

                      <div class="ec-phone__addon-list" *ngIf="previewRecommendations.length">
                        <div class="ec-phone__addon" *ngFor="let addon of previewRecommendations">
                          <img class="ec-phone__addon-img" [src]="addon.image" />
                          <div class="ec-phone__addon-meta">
                            <div class="ec-phone__addon-name">
                              <span class="ec-phone__addon-qty" *ngIf="addon.previewQuantity > 1"
                                >{{ addon.previewQuantity }}x </span
                              >{{ addon.product_name }}
                            </div>
                            <div class="ec-phone__addon-oos" *ngIf="addon.previewOutOfStock">
                              {{ "This item is currently out of stock" | translate }}
                            </div>
                            <div class="ec-phone__addon-price" *ngIf="!addon.previewOutOfStock">
                              {{ addon.retail_price_per_item
                                | currency : addon.currency : addon.currency_symbol + ' ' }}
                            </div>
                          </div>
                          <span class="ec-phone__addon-add"
                            [class.ec-phone__addon-add--off]="addon.previewOutOfStock">
                            + {{ "Add" | translate }}
                          </span>
                        </div>
                      </div>

                      <!-- Auto mode, or a list that resolved to nothing: the
                           storefront picks these from the customer's cart at
                           runtime, so there is nothing concrete to show. -->
                      <div class="ec-phone__addons-note" *ngIf="previewUsesSeriesFallback">
                        {{ "Products from the same series will be suggested automatically." | translate }}
                      </div>
                    </div>

                    <div class="ec-phone__total" *ngIf="selectedProducts.length">
                      <span class="ec-phone__total-label">{{ "Total" | translate }}</span>
                      <span class="ec-phone__total-amount">
                        {{ phonePreviewTotal | currency : phonePreviewCurrency : phonePreviewCurrencySymbol + ' ' }}
                      </span>
                    </div>
                  </div>
                  <!-- Custom Highlight sits directly above the voucher field,
                       which is where the checkout page puts it. -->
                  <div class="ec-phone__custom-highlight" *ngIf="showCustomHighlightPreview"
                    [innerHTML]="getSafeCustomHighlightHtml()"></div>
                  <div class="ec-phone__voucher" *ngIf="showVoucherCode">
                    <label class="ec-phone__voucher-label">{{ "Enter your voucher code" | translate }}</label>
                    <div class="ec-phone__voucher-row">
                      <input class="ec-phone__voucher-input" type="text" disabled
                        placeholder="{{ 'Voucher' | translate }}" />
                      <button type="button" class="ec-phone__voucher-btn" disabled>
                        {{ "Apply" | translate }}
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Personal Details -->
                <div class="ec-phone__details">
                  <div class="ec-phone__section-header">
                    <h4 class="ec-phone__section-title">{{ "Personal Details" | translate }}</h4>
                    <span class="ec-phone__chevron">
                      <i class="fi fi-rr-angle-small-down"></i>
                    </span>
                  </div>
                  <div class="ec-phone__details-body">
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">{{ "Full name" | translate }}</label>
                      <input class="ec-phone__field-input" type="text" disabled placeholder="{{ 'Full name' | translate }}" />
                    </div>
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">{{ "Email" | translate }}</label>
                      <input class="ec-phone__field-input" type="text" disabled placeholder="{{ 'Email address' | translate }}" />
                    </div>
                    <div class="ec-phone__field ec-phone__field--readonly">
                      <label class="ec-phone__field-label">{{ "Country | Phone Code" | translate }}</label>
                      <div class="ec-phone__country-code">
                        <img class="ec-phone__country-flag" [src]="getFlagImageURL(filteredCountry)" />
                        <span class="ec-phone__phone-code">| {{ getPhoneCode(filteredCountry) }}</span>
                      </div>
                    </div>
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">
                        {{ "Phone" | translate }}
                        <i class="fi fi-rr-info ec-phone__field-info"></i>
                      </label>
                      <input class="ec-phone__field-input" type="text" disabled placeholder="{{ 'Phone' | translate }}" />
                    </div>
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">{{ "Postcode" | translate }}</label>
                      <input class="ec-phone__field-input" type="text" disabled placeholder="{{ 'Postcode' | translate }}" />
                    </div>
                    <div class="ec-phone__field-row">
                      <div class="ec-phone__field">
                        <label class="ec-phone__field-label required">{{ "State" | translate }}</label>
                        <button type="button" class="ec-phone__field-select" disabled>
                          <i class="fi fi-rr-angle-small-down"></i>
                        </button>
                      </div>
                      <div class="ec-phone__field">
                        <label class="ec-phone__field-label required">{{ "City" | translate }}</label>
                        <button type="button" class="ec-phone__field-select" disabled>
                          <i class="fi fi-rr-angle-small-down"></i>
                        </button>
                      </div>
                    </div>
                    <div class="ec-phone__field">
                      <label class="ec-phone__field-label required">{{ "Address" | translate }}</label>
                      <textarea class="ec-phone__field-input ec-phone__field-textarea" disabled
                        placeholder="{{ 'Address' | translate }}"></textarea>
                    </div>
                    <button type="button" class="ec-phone__remark-btn" disabled>
                      + {{ "Add a remark" | translate }}
                      <span class="ec-phone__remark-opt">({{ "optional" | translate }})</span>
                    </button>
                    <div class="ec-phone__notice">
                      {{ "Please enter your shipping address to see the available delivery service." | translate }}
                    </div>
                  </div>
                </div>

                <!-- Payment Method -->
                <div class="ec-phone__payment">
                  <div class="ec-phone__section-header">
                    <h4 class="ec-phone__section-title">{{ "Payment Method" | translate }}</h4>
                    <span class="ec-phone__chevron">
                      <i class="fi fi-rr-angle-small-right"></i>
                    </span>
                  </div>
                  <div class="ec-phone__payment-method">
                    <span class="ec-phone__payment-key">{{ "METHOD" | translate }}</span>
                    <span class="ec-phone__payment-value">FPX</span>
                  </div>
                </div>
              </ng-container>

              <!-- ============ SPLIT THEME LAYOUT (non-Taiwan) ============
                   Mirrors the storefront's mobile split checkout: the store
                   header is suppressed and the link's own header runs edge to
                   edge, the order collapses behind a bar, and the form sits on
                   white below it.

                   The order summary is drawn open here. On the page it starts
                   closed — a phone cannot show the picker and the first form
                   field at once — but a preview that opened closed would show
                   the dealer a grey bar and nothing of what they configured.
                   The note under the phone says so. -->
              <ng-container *ngIf="isSplitPreview">
                <div class="ec-split">
                  <div class="ec-split__header" [innerHTML]="getSafeCustomHeaderHtml()"></div>

                  <div class="ec-split__bar">
                    <span class="ec-split__bar-label">
                      {{ "Order summary" | translate }}
                      <i class="fi fi-rr-angle-small-up"></i>
                    </span>
                    <span class="ec-split__bar-total">
                      {{ phonePreviewTotal | currency : phonePreviewCurrency : phonePreviewCurrencySymbol + ' ' }}
                    </span>
                  </div>

                  <!-- Order band — the flat grey panel the bar opens. -->
                  <div class="ec-split__summary">
                    <div class="ec-phone__products-label">{{ "Product/s:" | translate }}</div>
                    <div class="ec-phone__product-list" *ngIf="selectedProducts.length">
                      <ng-container *ngFor="let product of selectedProducts">
                        <div class="ec-phone__product" *ngIf="getProductData(product.product_id) as p">
                          <img class="ec-phone__product-img" [src]="p.isSubscriptionPlan ? getSubscriptionImage(product.product_id, product.quantity) : p.image" />
                          <div class="ec-phone__product-meta">
                            <div class="ec-phone__product-name">{{ p.isSubscriptionPlan ? getSubscriptionSelectedName(product.product_id, product.quantity) : p.product_name }}</div>
                            <div class="ec-phone__product-price">
                              {{ (p.isSubscriptionPlan ? getSubscriptionPrice(product.product_id, product.quantity) : p.retail_price_per_item) | currency : p.currency : p.currency_symbol + ' ' }}
                            </div>
                          </div>
                          <!-- Quantity Lock: the checkout page drops the − / + for a
                               locked product and shows the fixed quantity alone. -->
                          <div class="ec-phone__qty"
                            [class.ec-phone__qty--locked]="isQuantityLocked(product.product_id)">
                            <span class="ec-phone__qty-btn"
                              *ngIf="!isQuantityLocked(product.product_id)">−</span>
                            <span class="ec-phone__qty-value">{{ product.quantity }}</span>
                            <span class="ec-phone__qty-btn"
                              *ngIf="!isQuantityLocked(product.product_id)">+</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="ec-phone__empty" *ngIf="!selectedProducts.length">
                      {{ "Select products from the left to preview" | translate }}
                    </div>

                    <!-- Promotion — mirrors the PWP rows of the storefront's
                         Promotion section: the PWP products the selected
                         products unlock, at the quantity the link pre-selects,
                         with a bundle's offered picks beneath. Hidden rows and
                         hidden picks are left out, as the checkout page leaves
                         them out. Shown expanded; on the storefront the
                         customer taps the header to open it. -->
                    <div class="ec-phone__addons ec-phone__addons--promo" *ngIf="previewPwpRows.length">
                      <div class="ec-phone__addons-head">
                        <i class="fi fi-rr-gift"></i>
                        <span class="ec-phone__addons-title">{{ "Promotion" | translate }}</span>
                        <span class="ec-phone__addons-count">{{ previewPwpRows.length }}</span>
                        <i class="fi fi-rr-angle-small-up ec-phone__addons-chevron"></i>
                      </div>

                      <div class="ec-phone__addon-list">
                        <ng-container *ngFor="let row of previewPwpRows">
                          <div class="ec-phone__addon ec-phone__addon--pwp">
                            <img class="ec-phone__addon-img" [src]="row.image" />
                            <div class="ec-phone__addon-meta">
                              <div class="ec-phone__addon-name">{{ row.product_name }}</div>
                              <div class="ec-phone__addon-promo">{{ row.promotion_name }}</div>
                            </div>
                            <span class="ec-phone__addon-price ec-phone__addon-price--pwp">
                              <ng-container *ngIf="row.price > 0; else previewPwpFree">
                                {{ row.price | currency : row.currency : row.currency_symbol + ' ' }}
                              </ng-container>
                              <ng-template #previewPwpFree>{{ "Free" | translate }}</ng-template>
                            </span>
                            <!-- Quantity Lock drops the − / + here too. -->
                            <div class="ec-phone__qty ec-phone__qty--sm"
                              [class.ec-phone__qty--locked]="row.locked">
                              <span class="ec-phone__qty-btn" *ngIf="!row.locked">−</span>
                              <span class="ec-phone__qty-value">{{ row.quantity }}</span>
                              <span class="ec-phone__qty-btn" *ngIf="!row.locked">+</span>
                            </div>
                          </div>

                          <div class="ec-phone__picks" *ngFor="let group of row.pick_groups">
                            <div class="ec-phone__picks-head">
                              <span [innerHTML]="'Pick <strong>{0}</strong> of the following option:' | translate : [group.limit]"></span>
                              <span class="ec-phone__picks-count"
                                [class.ec-phone__picks-count--full]="group.limit > 0 && group.picked >= group.limit">
                                ({{ group.picked }}/{{ group.limit }})
                                <i class="fi fi-rr-angle-small-down"></i>
                              </span>
                            </div>
                            <div class="ec-phone__pick" *ngFor="let pick of group.products">
                              <img class="ec-phone__pick-img" [src]="pick.image" />
                              <span class="ec-phone__pick-name">{{ pick.product_name }}</span>
                              <span class="ec-phone__pick-qty">
                                <span class="ec-phone__pick-btn" *ngIf="!pick.locked">−</span>
                                <span class="ec-phone__pick-value">{{ pick.quantity }}</span>
                                <span class="ec-phone__pick-btn" *ngIf="!pick.locked">+</span>
                              </span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>

                    <div class="ec-phone__addons" *ngIf="productRecommendationsEnabled">
                      <div class="ec-phone__addons-head">
                        <i class="fi fi-rr-shopping-cart"></i>
                        <span class="ec-phone__addons-title">
                          {{ "Recommended Add-ons" | translate }}
                        </span>
                        <span class="ec-phone__addons-count" *ngIf="previewRecommendations.length">
                          {{ previewRecommendations.length }}
                        </span>
                      </div>
                      <div class="ec-phone__addon-list" *ngIf="previewRecommendations.length">
                        <div class="ec-phone__addon" *ngFor="let addon of previewRecommendations">
                          <img class="ec-phone__addon-img" [src]="addon.image" />
                          <div class="ec-phone__addon-meta">
                            <div class="ec-phone__addon-name">
                              <span class="ec-phone__addon-qty" *ngIf="addon.previewQuantity > 1"
                                >{{ addon.previewQuantity }}x </span
                              >{{ addon.product_name }}
                            </div>
                            <div class="ec-phone__addon-oos" *ngIf="addon.previewOutOfStock">
                              {{ "This item is currently out of stock" | translate }}
                            </div>
                            <div class="ec-phone__addon-price" *ngIf="!addon.previewOutOfStock">
                              {{ addon.retail_price_per_item
                                | currency : addon.currency : addon.currency_symbol + ' ' }}
                            </div>
                          </div>
                          <span class="ec-phone__addon-add"
                            [class.ec-phone__addon-add--off]="addon.previewOutOfStock">
                            + {{ "Add" | translate }}
                          </span>
                        </div>
                      </div>
                      <div class="ec-phone__addons-note" *ngIf="previewUsesSeriesFallback">
                        {{ "Products from the same series will be suggested automatically." | translate }}
                      </div>
                    </div>

                    <div class="ec-phone__total" *ngIf="selectedProducts.length">
                      <span class="ec-phone__total-label">{{ "Total" | translate }}</span>
                      <span class="ec-phone__total-amount">
                        {{ phonePreviewTotal | currency : phonePreviewCurrency : phonePreviewCurrencySymbol + ' ' }}
                      </span>
                    </div>
                  </div>

                  <!-- Custom Highlight. This theme puts it directly under the
                       order summary at phone width, outside the band so it stays
                       on screen when the bar collapses the order away. -->
                  <div class="ec-phone__custom-highlight ec-phone__custom-highlight--split"
                    *ngIf="showCustomHighlightPreview"
                    [innerHTML]="getSafeCustomHighlightHtml()"></div>

                  <!-- Form column. Labels sit inside the fields on this theme. -->
                  <div class="ec-split__form">
                    <h4 class="ec-split__form-title">{{ "Delivery" | translate }}</h4>

                    <div class="ec-split__field">
                      <span class="ec-split__field-label required">{{ "Full name" | translate }}</span>
                    </div>
                    <div class="ec-split__field">
                      <span class="ec-split__field-label required">{{ "Postcode" | translate }}</span>
                    </div>
                    <div class="ec-split__field-row">
                      <div class="ec-split__field">
                        <span class="ec-split__field-label required">{{ "State" | translate }}</span>
                        <i class="fi fi-rr-angle-small-down ec-split__field-caret"></i>
                      </div>
                      <div class="ec-split__field">
                        <span class="ec-split__field-label required">{{ "City" | translate }}</span>
                        <i class="fi fi-rr-angle-small-down ec-split__field-caret"></i>
                      </div>
                    </div>
                    <div class="ec-split__field ec-split__field--tall">
                      <span class="ec-split__field-label required">{{ "Address" | translate }}</span>
                    </div>
                    <button type="button" class="ec-phone__remark-btn" disabled>
                      + {{ "Add a remark" | translate }}
                      <span class="ec-phone__remark-opt">({{ "optional" | translate }})</span>
                    </button>
                    <div class="ec-phone__notice">
                      {{ "Please enter your shipping address to see the available delivery service." | translate }}
                    </div>

                    <!-- Dial-code chip and Phone share a row on this theme. -->
                    <div class="ec-split__field-row">
                      <div class="ec-split__field ec-split__field--chip">
                        <span class="ec-split__field-label">{{ "Country | Phone Code" | translate }}</span>
                        <span class="ec-split__chip">
                          <img class="ec-phone__country-flag" [src]="getFlagImageURL(filteredCountry)" />
                          <span class="ec-phone__phone-code">| {{ getPhoneCode(filteredCountry) }}</span>
                        </span>
                      </div>
                      <div class="ec-split__field">
                        <span class="ec-split__field-label required">{{ "Phone" | translate }}</span>
                      </div>
                    </div>

                    <div class="ec-split__card">
                      <div class="ec-split__card-head">
                        <span class="ec-split__card-title">{{ "Payment Method" | translate }}</span>
                        <span class="ec-phone__chevron">
                          <i class="fi fi-rr-angle-small-down"></i>
                        </span>
                      </div>
                      <div class="ec-split__card-body">
                        <div class="ec-split__pay-row">FPX</div>
                      </div>
                    </div>

                    <button type="button" class="ec-split__discount" disabled *ngIf="showVoucherCode">
                      <i class="fi fi-rr-tags"></i>
                      {{ "Add discount" | translate }}
                    </button>

                    <!-- Total above Proceed, with what is being bought. -->
                    <div class="ec-split__cta-total">
                      <span class="ec-split__cta-thumbs" *ngIf="splitPreviewThumbs.length">
                        <span class="ec-split__cta-thumb" *ngFor="let thumb of splitPreviewThumbs">
                          <img [src]="thumb.product.image" />
                          <span class="ec-split__cta-badge" *ngIf="thumb.quantity > 1">
                            {{ thumb.quantity }}
                          </span>
                        </span>
                        <span class="ec-split__cta-more" *ngIf="splitPreviewThumbsOverflow">
                          +{{ splitPreviewThumbsOverflow }}
                        </span>
                      </span>
                      <span class="ec-split__cta-label">
                        {{ "Total" | translate }}
                        <span class="ec-split__cta-count">
                          {{ selectedProducts.length }}
                          {{ (selectedProducts.length === 1 ? "item" : "items") | translate }}
                        </span>
                      </span>
                      <span class="ec-split__cta-amount">
                        {{ phonePreviewTotal | currency : phonePreviewCurrency : phonePreviewCurrencySymbol + ' ' }}
                      </span>
                    </div>

                    <div class="ec-split__einvoice">
                      <span class="ec-phone__einvoice-box"></span>
                      <span class="ec-phone__einvoice-label">{{ "E-Invoice Required" | translate }}</span>
                    </div>

                    <button type="button" class="ec-phone__pay-btn" disabled
                      [ngStyle]="{
                        'background-color': generateForm.get('design_payment_button_color')?.value || '#45489D'
                      }">
                      {{ "Proceed to Payment" | translate }}
                    </button>
                    <p class="ec-phone__agree">
                      {{ "By continuing, you agree to our" | translate }}
                      <a class="ec-phone__agree-link">{{ "terms of use" | translate }}</a>
                      {{ "and" | translate }}
                      <a class="ec-phone__agree-link">{{ "privacy policy" | translate }}</a>.
                    </p>

                    <!-- Custom Note. Below Proceed to Payment and its terms line
                         on this theme — no card of its own, since the split
                         checkout owns its surfaces and has none to match. -->
                    <div class="ec-phone__custom-note" *ngIf="showCustomNotePreview"
                      [innerHTML]="getSafeCustomNoteHtml()"></div>

                    <div class="ec-phone__custom-footer"
                      *ngIf="showCustomFooterPreview"
                      [innerHTML]="getSafeCustomFooterHtml()"></div>
                  </div>
                </div>
              </ng-container>

              <!-- Footer pay button + agreement + e-invoice.
                   The split layout carries its own, inside the white form
                   column where the design puts it. -->
              <div class="ec-phone__footer" *ngIf="!isSplitPreview">
                <button type="button" class="ec-phone__pay-btn" disabled
                  [ngStyle]="{
                    'background-color': generateForm.get('design_payment_button_color')?.value || '#45489D'
                  }">
                  {{ "Proceed to Payment" | translate }}
                </button>
                <p class="ec-phone__agree">
                  {{ "By continuing, you agree to our" | translate }}
                  <a class="ec-phone__agree-link">{{ "terms of use" | translate }}</a>
                  {{ "and" | translate }}
                  <a class="ec-phone__agree-link">{{ "privacy policy" | translate }}</a>.
                </p>
                <div class="ec-phone__einvoice" *ngIf="!isTaiwan">
                  <span class="ec-phone__einvoice-box"></span>
                  <span class="ec-phone__einvoice-label">{{ "E-Invoice Required" | translate }}</span>
                </div>

                <!-- Custom Note, in its own card. Below Proceed to Payment, and
                     last in the column, which is where the classic theme puts it
                     at phone width — the preview is a phone mock, so it follows
                     that copy rather than the desktop one up by the order card.
                     Never drawn for Taiwan; showCustomNotePreview covers it. -->
                <div class="ec-phone__custom-note-card" *ngIf="showCustomNotePreview">
                  <div class="ec-phone__custom-note" [innerHTML]="getSafeCustomNoteHtml()"></div>
                </div>

                <div class="ec-phone__custom-footer"
                  *ngIf="showCustomFooterPreview"
                  [innerHTML]="getSafeCustomFooterHtml()"></div>
              </div>
            </div>
          </div>

          <div class="ec-preview__cta" *ngIf="showFloatingCta">
            <button type="button" class="btn btn-primary w-100" (click)="generatelink()"
              [disabled]="buttonFreeze" *ngIf="!updateLink">
              <i class="fi fi-rr-link mr-1"></i>
              {{ "Create Checkout Link" | translate }}
            </button>
            <button type="button" class="btn btn-primary w-100" (click)="updatelink()"
              [disabled]="buttonFreeze" *ngIf="updateLink">
              <i class="fi fi-rr-check mr-1"></i>
              {{ "Save Changes" | translate }}
            </button>
          </div>
        </div>
      </aside>

      <!-- Popup editor for the custom HTML block whose expand button was
           pressed. Bound to that block's form control, so it edits in place. -->
      <div class="ec-html-popup" *ngIf="htmlPopup as editor"
        (mousedown)="onHtmlPopupBackdropMousedown($event)"
        (click)="onHtmlPopupBackdropClick($event)">
        <div class="ec-html-popup__dialog" #htmlPopupDialog
          role="dialog" aria-modal="true" [attr.aria-label]="editor.title | translate"
          (keydown)="trapHtmlPopupFocus($event, htmlPopupDialog)">
          <header class="ec-html-popup__head">
            <span class="ec-card__icon">
              <i class="fi fi-rr-comment-code"></i>
            </span>
            <div class="ec-html-popup__heading">
              <h2 class="ec-card__title">{{ editor.title | translate }}</h2>
              <p class="ec-helper">{{ "Changes apply as you type. Press Esc to close." | translate }}</p>
            </div>
            <div class="ec-html-popup__actions">
              <button type="button" class="ec-reset-btn" (click)="editor.reset()">
                {{ editor.resetLabel | translate }}
              </button>
              <button type="button" class="btn btn-primary" (click)="closeHtmlPopup()">
                {{ "Done" | translate }}
              </button>
            </div>
          </header>

          <div class="ec-html-popup__body">
            <textarea #htmlPopupCode class="ec-textarea ec-textarea--code ec-html-popup__code"
              [formControl]="htmlPopupControl" spellcheck="false"
              [attr.aria-label]="editor.title | translate"></textarea>

            <!-- Inert: a link in the dealer's markup must not navigate the
                 dashboard away mid-edit. -->
            <div class="ec-html-popup__preview">
              <div class="ec-label">{{ "Preview" | translate }}</div>
              <div class="ec-html-popup__stage">
                <div class="ec-html-popup__canvas" inert [innerHTML]="editor.preview()"></div>
                <p class="ec-html-popup__empty" *ngIf="!htmlPopupControl.value">
                  {{ "Nothing to preview yet." | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Success state -->
  <div class="ec-main" *ngIf="checkoutSuccess">
    <div class="ec-success">
      <div class="ec-success__icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#10B981" />
        </svg>
      </div>
      <h3 class="ec-success__title">
        {{ "Checkout Link Ready" | translate }}
      </h3>
      <p class="ec-success__subtitle">
        {{ "Your custom express checkout sales link is prepared. Share it across your marketing channels to capture instant sales." | translate }}
      </p>

      <div class="ec-success__field">
        <label class="ec-label">{{ "YOUR LINK URL" | translate }}</label>
        <div class="ec-success__input-group">
          <a class="ec-input ec-success__link" [href]="expressUrl" target="_blank" rel="noopener noreferrer">
            {{ expressUrl }}
          </a>
          <button class="ec-btn ec-btn--primary" type="button" (click)="copyGenerateLink()">
            {{ "Copy Link" | translate }}
          </button>
        </div>
      </div>

      <!-- Product Link URL — shown when the user enabled Product Link during create -->
      <div class="ec-success__field" *ngIf="showProductLinkResult">
        <label class="ec-label">{{ "PRODUCT LINK URL" | translate }}</label>
        <div class="ec-success__input-group">
          <a class="ec-input ec-success__link" [href]="productLinkResultUrl" target="_blank" rel="noopener noreferrer">
            {{ productLinkResultDisplay || productLinkResultUrl }}
          </a>
          <button class="ec-btn ec-btn--primary" type="button" (click)="copyProductLink()">
            {{ "Copy Link" | translate }}
          </button>
        </div>
      </div>

      <div class="ec-success__actions">
        <button class="ec-success__share"
          *ngIf="!isStoreInfoLoading && !isSvoStore"
          [disabled]="!nexusSsoLink"
          (click)="shareToSocialMedia()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
              fill="currentColor" />
          </svg>
          {{ "Share on Social Media" | translate }}
        </button>
        <button class="ec-btn ec-btn--outline" routerLink="/dashboard/express-checkout">
          {{ "Back to Listing Page" | translate }}
        </button>
      </div>
    </div>
  </div>

  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ "Delete List" | translate }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="text-secondary">
        {{ "Are you sure you want to delete this List?" | translate }}
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary" (click)="modal.close('Save click')">
        {{ "Cancel" | translate }}
      </button>
      <button type="button" class="btn btn-danger" (click)="modal.close('delete')">
        {{ "Delete" | translate }}
      </button>
    </div>
  </ng-template>

  <ng-template #success let-modal>
    <div class="modal-body text-center">
      <h4>{{ "Successfully Update" | translate }}</h4>
      <button class="btn btn-primary" type="button" (click)="modal.close('Send click')">
        {{ "Close" | translate }}
      </button>
    </div>
  </ng-template>
</div>
